module.exports = __webpack_public_path__ + "static/media/hair-dresser.dc474d18.jpg";